import { NgModule } from '@angular/core';
import { RememberScrollPositionDirective } from './directives/remember-scroll-position.directive';
import { RememberScrollPosition } from './services/scroll-position.service';

@NgModule({
  declarations: [RememberScrollPositionDirective],
  exports: [RememberScrollPositionDirective],
  providers: [RememberScrollPosition]
})
export class RememberScrollPositionModule {
}
